import {
  ALL_FORMATS,
  BlobSource,
  Input,
  Mp4OutputFormat,
  WebMOutputFormat,
  type AudioCodec,
} from "mediabunny";
import type { VideoContainer } from "../../core/export/videoCapabilities";

export type SourceAudioInfo = {
  hasAudio: boolean;
  codec: AudioCodec | null;
  compatible: boolean;
  reason: string | null;
};

function outputFormat(container: VideoContainer) {
  return container === "mp4" ? new Mp4OutputFormat() : new WebMOutputFormat();
}

export async function inspectSourceAudio(file: File, container: VideoContainer): Promise<SourceAudioInfo> {
  const input = new Input({
    formats: ALL_FORMATS,
    source: new BlobSource(file),
  });

  const track = await input.getPrimaryAudioTrack();
  if (!track) {
    return {
      hasAudio: false,
      codec: null,
      compatible: true,
      reason: null,
    };
  }

  const codec = await track.getCodec();
  if (!codec) {
    return {
      hasAudio: true,
      codec: null,
      compatible: false,
      reason: "The source audio codec could not be identified for passthrough.",
    };
  }

  const compatible = outputFormat(container).getSupportedAudioCodecs().includes(codec);
  return {
    hasAudio: true,
    codec,
    compatible,
    reason: compatible
      ? null
      : `${codec.toUpperCase()} audio cannot be copied directly into ${container.toUpperCase()}.`,
  };
}
